<template>
  <div style="display: flex; align-items: flex-end;">
    <div class="text-column">
      <div class="title-container" :style="titleContainerBgStyle">
        <p class="title-text">{{ headerText }}</p>
      </div>
      <div class="description-container" :style="descriptionContainerBgStyle">
        <p class="description-text" :style="{ lineHeight: lineHeight, fontSize: fontSize }">{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const midiaBg = require("../../../assets/tarjas/panela-sportv/midia-vertical-container.png");
const titleContainerBg = require("../../../assets/tarjas/panela-sportv/midia-texto-titulo.png");
const descriptionContainerBg = require("../../../assets/tarjas/panela-sportv/midia-texto-descricao.png");

export default {
  props: {
    headerText: String,
    text: String,
    lineHeight: String,
    fontSize: String,
  },
  data() {
    return {};
  },
  computed: {
    textColumnStyle() {
      const size = `min-height: ${this.midiaSize.height/3}px`;
      return `${size};`;
    },
    titleContainerBgStyle() {
      const backgroundStyle = `background-image: url(${titleContainerBg}); background-repeat: round`;
      return `${backgroundStyle}`
    },
    descriptionContainerBgStyle() {
      const backgroundStyle = `background-image: url(${descriptionContainerBg}); background-repeat: no-repeat;  background-size: cover; background-size: 100% 100%;`;
      return `${backgroundStyle}`;
    },
    midiaBgStyle() {
      const backgroundStyle = `background-image: url(${midiaBg}); background-repeat: round; background-size: contain;`;
      return `${backgroundStyle};`;
    }
  },
};
</script>

<style scoped lang="scss">
.title-text {
  font-family: "Galeana-Condensed-Black", sans-serif;
  font-weight: 600;
  color: rgb(255, 255, 255);
  white-space: nowrap;
  font-size: 2.8rem; 
  line-height: 2.5rem;
}

.description-text {
  font-family: "Galeana-Condensed-Regular", sans-serif;
  font-weight: 600;
  color: rgb(1, 83, 121);
  margin-bottom: 0;
}

.text-column {
  flex-grow: 1;
  margin-left: -90px;
}
.title-container {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 60px;
  padding-right: 60px;
  padding-left: 60px;
  width: 100%;
}
.description-container {
  width: 100%;
  margin-top: -70px;
  min-height: 100px;
  padding-block: 20px;
  margin-bottom: 10px;
  padding-left: 50px;
  padding-right: 50px;
}
</style>
